import axios from 'axios'

export default {
    refreshResources: ({commit, state}) => new Promise((resolve, reject) => {
        commit('switchLoading', { state: true })

        axios.get("/" + state.language + "/api/resources")
        .then(resp => {
            commit('updateResources', { resources: resp.data })
            resolve(resp)
        })
        .catch(err => {
            console.log(err.message)
            reject(err)
        }) 
    }),
    refreshTopics({commit, state}) {
        axios.get("/" + state.language + "/api/topics")
            .then(resp => {
                commit('updateTopics', {
                    topics: resp.data
                })
            }).catch( err => {
                console.log(err.message)
            })
    },
    refreshResourceTypes({commit, state}) {
        axios.get("/" + state.language + "/api/resource-types")
            .then(resp => {
                commit('updateResourceTypes', {
                    resourceTypes: resp.data
                })
            }).catch( err => {
                console.log(err.message)
            })
    },
    refreshLanguages({commit, state}) {
        axios.get("/" + state.language + "/api/languages")
            .then(resp => {
                commit('updateLanguages', {
                    languages: resp.data
                })
            }).catch( err => {
                console.log(err.message)
            })
    },
}
